<template>
    <div class="app">
      <DefaultHeader id="pgiHeader" :totalNotif="notifCount" @did-tap-notification="didTapNotification" @did-logout="didLogout" @gadaiEmasActive="gadaiEmasActive" @cabangChanged="reloadMainView" />
      <div class="app-body">
          <AppSidebar fixed>
          <SidebarHeader/>
          <SidebarForm/>
            <div class="search-dropdown p-2">
            <input
            type="text"
            class="form-control"
            placeholder="Cari menu..."
            v-model="searchQuery"
            @input="handleSearch"
            @keydown.down.prevent="moveHighlight(1)"
            @keydown.up.prevent="moveHighlight(-1)"
            @keydown.enter.prevent="selectHighlighted"
            />

            <ul v-if="filteredOptions.length" class="list-group mt-2">
            <li
            v-for="(option, index) in filteredOptions"
            :key="index"
            class="list-group-item list-group-item-action"
            :class="{ active: index === highlightedIndex }"
            @click="goTo(option.url)"
            style="cursor: pointer;"
            >
            {{ option.name }}
            </li>

            </ul>
        </div>

          <div class="sidebar-user">
            <div class="sidebar-user-data">
              <div class="sidebar-user-icon">
                <i class="fa fa-user"></i>
              </div>
              <div class="sidebar-user-info">
                  <span class="sidebar-user-name">
                      {{dashboardName}}
                      <span class="header-user-setting ml-2" v-b-tooltip.hover title="Change Password" @click="$bvModal.show('modal-change-password')">
                          <i class="fa fa-cog"></i>
                      </span>
                  </span>
                  <span class="sidebar-user-position">{{dashboardRole}}</span>
              </div>
            </div>
            <div class="sidebar-user-cabang">
              <!-- <span class="mb-0">Cabang</span> -->
              <!-- <strong> {{dashboardCabang}} </strong> -->
              <CabangOption @cabangChanged="reloadMainView" />
            </div>
          </div>
          <p class="" hidden>
              {{ count }}
          </p>
          <SidebarNav :navItems="nav"></SidebarNav>
            <div class="sidebar-last-login">
                <span style="font-size: 12px;">Last Login</span><br>
                <span style="font-size: 12px;"> {{ lastLogin }}</span>
            </div>
          <SidebarFooter/>
          <!-- <SidebarMinimizer/> -->
        </AppSidebar>
        <main class="main">
          <Breadcrumb id="pgiBreadCrumb" :list="list"/>
          <div class="container-fluid">
            <router-view :key="mainViewKey" @changeSidebarNav="changeSidebarNav" ></router-view>
          </div>
        </main>
        <AppAside fixed>
          <!--aside-->
          <!-- <DefaultAside/> -->
        </AppAside>
      </div>
      <DefaultFooter id="pgiFooter" />
    </div>
  </template>
  
  <script>
  import nav from '@/_nav'
  import { Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside } from '@coreui/vue'
  // import DefaultAside from './DefaultAside'
  import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
  import DefaultHeader from './DefaultHeader'
  import DefaultFooter from './DefaultFooter'
  import Breadcrumb from './CustomBreadcrumb'
  import CabangOption from '../components/cabang/CabangOption'

  const getMenuPermissions = () => new Set(
      ['menuTop', 'menuChildren']
          .reduce((codes, key) => codes.concat((localStorage.getItem(key) || '').split(',')), [])
          .map(code => code.trim())
          .filter(Boolean)
  )

  const hasMenuPermission = (menuPermissions, code) => {
      return String(code || '')
          .split(',')
          .map(item => item.trim())
          .filter(Boolean)
          .some(item => item.toUpperCase() === 'ALL' || menuPermissions.has(item))
  }
  
  export default {
      name: 'DefaultContainer',
      components: {
          AppSidebar,
          AppAside,
          Breadcrumb,
          // DefaultAside,
          DefaultHeaderDropdownAccnt,
          SidebarForm,
          SidebarFooter,
          SidebarHeader,
          SidebarNav,
          SidebarMinimizer,
          DefaultFooter,
          DefaultHeader,
          CabangOption
      },
      data () {
          return {
              nav: [],
              dashboardName: localStorage.getItem("name"),
              dashboardRole: localStorage.getItem("role"),
              dashboardCabang: localStorage.getItem("activeCabang"),
              lastLogin: localStorage.getItem("lastLogin"),
              // hasNotification: false,
              notifCount: 0,
              sse: null,
              os: null,
              firebase: null,

              searchQuery: '',
              allOptions: [],
              filteredOptions: [],
              highlightedIndex: -1,
              mainViewKey: 0,

          }
      },
      computed: {
        count(){
              const elements = document.querySelectorAll('a');
              elements.forEach(element => {
                  if (element.textContent.includes('Dashboard')) {
                      const existingSpans = element.querySelectorAll('span');
                      existingSpans.forEach(span => span.remove());
                 if (this.$store.state.readCount != 0) {
                  
                     const newSpan = document.createElement('span');
                     
                     // Create new <span> element
                      newSpan.textContent = this.$store.state.readCount;
                      newSpan.style.position = 'absolute'; 
                      newSpan.style.top = '50%';
                      newSpan.style.right = '1rem'; 
                      newSpan.style.transform = 'translateY(-50%)'; 
                      newSpan.style.padding = '0px 5px';
                      newSpan.style.borderRadius = '100%';
                      newSpan.style.background = 'red';
                      newSpan.style.color = 'white';
                      newSpan.style.fontSize = '0.75rem'; 
                      
                      element.appendChild(newSpan);
                  }
                      
                  
                  }
              });
  
              return this.$store.state.readCount
          },
          name () {
              return this.$route.name
          },
          list () {
              return this.$route.matched.filter((route) => (route.name || route.meta.label) && !route.meta.hideInBreadcrumb)
          }
      },
   
      methods: {
        getUnreadCount() {
              this.$axios.get('informasi-umum/count-unreads')
              .then(response => {
              this.$store.state.readCount = response.data.id
              const elements = document.querySelectorAll('a');
              elements.forEach(element => {
                  if (element.textContent.includes('Dashboard')) {
                      const existingSpans = element.querySelectorAll('span');
                      existingSpans.forEach(span => span.remove());
  
                      if (this.$store.state.readCount != 0) {
                      const newSpan = document.createElement('span');
                      
                        // Create new <span> element
                          newSpan.textContent = this.$store.state.readCount;
                          newSpan.style.position = 'absolute'; 
                          newSpan.style.top = '50%';
                          newSpan.style.right = '1rem'; 
                          newSpan.style.transform = 'translateY(-50%)'; 
                          newSpan.style.padding = '0px 5px';
                          newSpan.style.borderRadius = '100%';
                          newSpan.style.background = 'red';
                          newSpan.style.color = 'white';
                          newSpan.style.fontSize = '0.75rem'; 
                          
                          // Append new elements to the anchor
                          
                          element.appendChild(newSpan);
                      }
                  
                  }
              });
              })
              .catch(error => {
              console.error(error)
              })
        },
        gadaiEmasActive(index){
              if(index == false){
                  let idxTop = this.nav.findIndex(index => index.code == 'GAD')
                  let idxChild =  this.nav[idxTop].children.findIndex(index => index.code == 'GEM')
                  let menuChildren = localStorage.getItem("menuChildren")
      
                  let arrayMenuChildren = menuChildren.split(",");
                  let filteredArray = arrayMenuChildren.filter(code => code !== 'GEM');
  
                  // Join the filtered array back into a string
                  let resultString = filteredArray.join(',');
                  localStorage.setItem("menuChildren", resultString)
      
                  if (this.$router.currentRoute.path.includes(this.nav[idxTop].children[idxChild].url) ) {
                      this.$router.replace('/');
                  }
                  this.nav[idxTop].children = this.nav[idxTop].children.filter(item => item.code != 'GEM')
                  
              }else{
                  let oldMenuChildren = localStorage.getItem("oldMenuChildren")
                  localStorage.setItem("menuChildren", oldMenuChildren)
  
                  this.validateNavItem()
              }
        },
        changeSidebarNav(){
              let menuPermissions = getMenuPermissions()

              let copyNav = JSON.parse(JSON.stringify(nav.items))

              let menu = copyNav.filter(item => hasMenuPermission(menuPermissions, item.code))

              menu.forEach(item => this.checkChildren(item, menuPermissions))
  
              this.nav = menu
        },
        reloadMainView(){
              this.mainViewKey++
        },
  
        validateNavItem(){
              let menuPermissions = getMenuPermissions()

              let copyNav = JSON.parse(JSON.stringify(nav.items))

              let menu = copyNav.filter(item => hasMenuPermission(menuPermissions, item.code))
                  if(localStorage.getItem('role') == 'Kasir1'){
                      menu = menu.filter(item => item.code != 'INF')
                  }
              menu.forEach(item => this.checkChildren(item, menuPermissions))
              
              let menuFix = menu.filter((item,index=0)=>{
                  if(item.code == 'EKS' && (localStorage.getItem('isauthorized') == 'false')){
                      let newAksesLapeks = {
                          name: 'Akses Laporan Eksekutif',
                          url: '/akses-laporan-eksekutif',
                          icon: 'fa fa-key',
                          code: 'ALE',
                      }
                      menu.splice(index, 1);
                      menu.push(newAksesLapeks)
                  }
                  index++
              })
  
              this.nav = menu
  
        },
  
        checkChildren(item, menuPermissions = getMenuPermissions()){
              if(item.children != undefined){
                  if(item.children.length == 0){
                      delete item.children
                  }
                  item.children = item.children.filter(child => hasMenuPermission(menuPermissions, child.code))
                  item.redirect = item.children[0] ? item.children[0].url : '/'
              }
        },
  
        didLogout() {
  
              if(this.firebase != null && this.firebase.messaging.isSupported()) {
  
                  // Invalidate token
                  let fcmToken = localStorage.getItem("fcmToken")
                  if(fcmToken != null) {
  
                      let payload = new FormData()
                      payload.append("token", fcmToken)
                      this.$axios.post("/user/logout", payload)
                      this.firebase.messaging().deleteToken(fcmToken)
  
                  }
  
              }
  
              // Clears localstorage
              this.$axios.defaults.headers.common['Authorization'] = ""
              var version = localStorage.getItem("version")
              localStorage.clear()
              sessionStorage.clear()
              localStorage.setItem("version", version)
  
              this.$router.push("/login")
  
        },
  
        didTapNotification() {
              this.notifCount = 0
        },

        prepareSearchOptions() {
            const flatten = [];
            this.nav.forEach(item => {
            if (item.children && item.children.length > 0) {
                item.children.forEach(child => {
                flatten.push({ name: item.name+" -> "+child.name, url: child.url });
                });
            } else {
                flatten.push({ name: item.name+" -> "+item.name, url: item.url });
            }
            });
            this.allOptions = flatten;
        },


        goTo(url) {
            this.$router.push(url);
            this.searchQuery = '';
            this.filteredOptions = [];
        },
        moveHighlight(direction) {
            if (!this.filteredOptions.length) return;

            const maxIndex = this.filteredOptions.length - 1;
            let nextIndex = this.highlightedIndex + direction;

            if (nextIndex < 0) nextIndex = maxIndex;
            if (nextIndex > maxIndex) nextIndex = 0;

            this.highlightedIndex = nextIndex;
        },

        selectHighlighted() {
            if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredOptions.length) {
            const selected = this.filteredOptions[this.highlightedIndex];
            this.goTo(selected.url);
            }
        },

        handleSearch() {
            const query = this.searchQuery.toLowerCase();
            if (query === '') {
            this.filteredOptions = [];
            this.highlightedIndex = -1;
            return;
            }
            this.filteredOptions = this.allOptions.filter(item =>
            item.name.toLowerCase().includes(query)
            );
            this.highlightedIndex = 0;
        },
      
      },
  
      mounted(){

          this.getUnreadCount();
  
          this.interval = setInterval(() => {
          this.getUnreadCount();
          }, 30 * 60 * 1000);
      },
  
      beforeDestroy() {
          clearInterval(this.interval); 
        },
      created() {
  
          this.validateNavItem()
          this.prepareSearchOptions(); 
  
          // Auto-redirect to login page if token does not exist --> moved to router
          // if(localStorage.getItem("token") == null) {
          //     this.$router.push({ path: "/login" })
          // }
  
          let that = this
  
          /// ==== SETUP FIREBASE MESSAGING
          let firebase = this.$firebase
          this.firebase = firebase
  
          if(firebase.messaging.isSupported()) {
  
              let messaging = firebase.messaging()
  
              messaging.requestPermission().then(() => {
  
                  // Get Token
                  messaging.getToken().then((token) => {
                     
                      localStorage.setItem("fcmToken", token)
  
                      let payload = new FormData()
                      payload.append("token", token)
                      that.$axios.post("/user/fcm-token", payload).then(res => {
                      })
  
                  })
  
              }).catch((err) => {
                  console.log('Unable to get permission to notify.', err);
              });
  
              messaging.onMessage((payload) => {
  
                  new Notification(payload.notification.title, {
                      icon: payload.notification.icon,
                      body: payload.notification.body
                  })
                  console.log('Message received. ', payload);
                  that.notifCount++
  
              })  
  
              messaging.onTokenRefresh(() => {
  
                  messaging.getToken().then((refreshedToken) => {
  
                      console.log('Token refreshed.')
  
                      // Invalidate last token
                      let lastToken = localStorage.getItem("fcmToken")
  
                      if(lastToken != null) {
  
                          let payload = new FormData()
                          payload.append("token", lastToken)
  
                          that.$axios.post("/user/logout", payload)
  
                      }
  
                      // Set new token
                      localStorage.setItem("fcmToken", refreshedToken)
  
                      let payload = new FormData()
                      payload.append("token", refreshedToken)
                      that.$axios.post("/user/fcm-token", payload)
  
                  }).catch((err) => {
                      console.log('Unable to retrieve refreshed token ', err)
                  });
  
              });
  
          }
  
      },
  
  
      beforeDestroy() {
  
          if(this.firebase != null && this.firebase.messaging.isSupported()) {
  
              // Invalidate token
              let fcmToken = localStorage.getItem("fcmToken")
              if(fcmToken != null) {
  
                  let payload = new FormData()
                  payload.append("token", fcmToken)
                  this.$axios.post("/user/logout", payload)
                  this.firebase.messaging().deleteToken(fcmToken)
  
              }
  
          }
  
          this.$axios.defaults.headers.common['Authorization'] = ""
          var version = localStorage.getItem("version")
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem("version", version)
  
      }
  }
  </script>
  
